<template>
  <pageHeader
    :pageName="this.$store.getters.getWordLocale('txt_firma_detayi')"
  />
  <ForieLoader
    class="mt-10p bg-trans"
    v-show="showLoader && this.$store.state.domainSystemX == 1"
  />
  <TeLoader
    class="mt-10p bg-trans"
    v-show="showLoader && this.$store.state.domainSystemX == 2"
  />

  <div v-bind:class="{ container: true, visibility: showLoader == true }">
    <div class="d-flex justify-content-between company-detail-title-box">
      <h2>{{ companyName }}</h2>

      <div class="did-floating-label-content">
        <select
          @change="changeLanguage($event.target.value.toLowerCase())"
          class="did-floating-select form-control"
        >
          <option value="">
            {{
              this.$store.state.languagesNamesX.filter(
                (q) => q.code == this.$store.state.langCodeX
              )[0].name
            }}
          </option>
          <option
            v-for="(language, index) in this.$store.state.domainLanguages"
            :key="index"
            v-show="language.LangCode != this.$store.state.langCodeX"
            :value="language.LangCode"
          >
            {{
              this.$store.state.languagesNamesX.filter(
                (q) => q.code == language.LangCode
              )[0].name
            }}
          </option>
        </select>
        <label class="did-floating-label">{{
          this.$store.getters.getWordLocale("txt_dili_degistir")
        }}</label>
      </div>
    </div>
    <div v-show="showLoader == false">
      <div class="d-flex membership-package-description">
        <a>
          <img
            :src="'https://cdn.turkishexporter.com.tr' + memebrshipIcon"
          /><span>{{ membershipName }}</span></a
        >
        <a v-show="isVip">
          <img :src="require(`/src/assets/img/VIP.svg`)" />
          <span>{{ this.$store.getters.getWordLocale("txt_vip_uye") }}</span></a
        >
        <a v-show="years != ''">
          <img :src="require(`/src/assets/img/Years.svg`)" /><span
            >{{ years }}
            {{ this.$store.getters.getWordLocale("txt_yil") }}</span
          ></a
        >
      </div>
    </div>

    <div class="hr"></div>

    <div class="row">
      <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12">
        <div class="detail-description">
          <div class="detail-description-item">
            <span
              ><i class="material-icons-outlined">chat</i>
              {{
                this.$store.getters.getWordLocale("txt_firma_hakkinda")
              }}</span
            >
            <div>
              {{ companyDescription }}
            </div>
          </div>
          <div class="hr"></div>
          <div class="detail-description-item">
            <span
              ><i class="material-icons-outlined">chat</i>
              {{ this.$store.getters.getWordLocale("txt_sertifikalari") }}</span
            >

            <div v-if="certificates == ''" class="alert alert-warning">
              <i class="fa fa-info-circle me-2"></i>
              {{
                this.$store.getters.getWordLocale(
                  "txt_firmaya_ait_sertifika_bilgisi_bulunamadi"
                )
              }}
            </div>
            <p
              v-else
              v-for="(cer, cindx) in certificates.split(',')"
              :key="cindx"
            >
              {{ cer }}
            </p>
          </div>
          <div class="hr"></div>
          <div class="detail-description-item">
            <span
              ><i class="material-icons-outlined"> store_mall_directory </i>
              {{ this.$store.getters.getWordLocale("txt_marka") }}</span
            >
            <div v-if="brands == ''" class="alert alert-warning">
              <i class="fa fa-info-circle me-2"></i>
              {{
                this.$store.getters.getWordLocale(
                  "txt_firmaya_ait_marka_bilgisi_bulunamadi"
                )
              }}
            </div>
            <p v-else v-for="(brand, nindx) in brands.split(',')" :key="nindx">
              {{ brand }}
            </p>
          </div>
          <div class="hr"></div>
          <div class="detail-description-item">
            <span
              ><i class="material-icons-outlined"> book </i>
              {{ this.$store.getters.getWordLocale("txt_kategorileri") }}</span
            >
            <p v-for="(cat, ci) in companyCategories" :key="ci">
              {{ cat }}
            </p>
          </div>
          <div class="hr"></div>
          <div class="detail-description-item">
            <span
              ><i class="material-icons-outlined"> segment </i>
              {{
                this.$store.getters.getWordLocale("txt_faaliyet_alanlari")
              }}</span
            >
            <p v-for="(segment, si) in companySegments" :key="si">
              {{ segment }}
            </p>
          </div>
        </div>
      </div>
      <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
        <div class="right-col-box">
          <div class="detail-description-item">
            <span
              ><i class="material-icons-outlined">contact_page</i>
              {{
                this.$store.getters.getWordLocale("txt_firmaya_mesaj_gonder")
              }}</span
            >
            <form class="company-detail-form">
              <div
                v-show="this.$store.state.userLoggedInX == false"
                class="form-group"
              >
                <input
                  type="text"
                  v-bind:class="{
                    'form-control': true,
                    'red-border': v$.form.nameSurname.$errors.length > 0,
                    'green-border':
                      userNameOut && v$.form.nameSurname.$errors.length == 0,
                  }"
                  v-on:focusout="validateNamesurname"
                  v-model="form.nameSurname"
                  :placeholder="
                    this.$store.getters.getWordLocale('txt_adi_soyadi')
                  "
                />
                <div
                  class="form-error"
                  v-show="v$.form.nameSurname.$errors.length > 0"
                >
                  {{ this.$store.getters.getWordLocale("txt_adinizi_giriniz") }}
                </div>
              </div>
              <div
                v-show="this.$store.state.userLoggedInX == false"
                class="form-group"
              >
                <input
                  type="email"
                  v-on:focusout="validateEmail"
                  v-model="form.email"
                  v-bind:class="{
                    'form-control': true,
                    'red-border': v$.form.email.$errors.length > 0,
                    'green-border':
                      emailOut && v$.form.email.$errors.length == 0,
                  }"
                  :placeholder="
                    this.$store.getters.getWordLocale('txt_eposta_adresi')
                  "
                />
                <div
                  class="form-error"
                  v-show="v$.form.email.$errors.length > 0"
                >
                  {{
                    this.$store.getters.getWordLocale(
                      "txt_gecerli_eposta_adresi_giriniz"
                    )
                  }}
                </div>
              </div>

              <div class="row">
                <div class="col-12 col-sm-12">
                  <input
                    v-model="form.companyName"
                    type="text"
                    v-bind:class="{
                      'form-control': true,
                    }"
                    :placeholder="
                      toTitles(this.$store.getters.getWordLocale('txt_firma_adi'))
                    "
                  />
                </div>
              </div>

              <div class="form-group">
                <select
                  v-model="form.country"
                  @change="setSelectedCountryId($event)"
                  class="form-control"
                  v-bind:class="{
                    'form-control': true,
                    'red-border': v$.form.country.$errors.length > 0,
                    'green-border':
                      countryOut && v$.form.country.$errors.length == 0,
                  }"
                >
                  <option value="" selected disabled>
                    {{ this.$store.getters.getWordLocale("txt_ulke_sec") }}
                  </option>
                  <option
                    v-for="(country, pIndex) in countries"
                    :key="pIndex"
                    :value="country.countryCode.toLowerCase()"
                  >
                    {{ country.text }}
                  </option>
                </select>
                <div class="form-error" v-show="form.country == 0 && submitted">
                  {{ this.$store.getters.getWordLocale("txt_ulke_sec") }}
                </div>
              </div>
              <div class="form-group">
                <input
                  minlength="5"
                  maxlength="250"
                  v-on:focusout="validateSubject"
                  v-model="form.subject"
                  type="text"
                  v-bind:class="{
                    'form-control': true,
                    'red-border': v$.form.subject.$errors.length > 0,
                    'green-border':
                      subjectOut && v$.form.subject.$errors.length == 0,
                  }"
                  :placeholder="this.$store.getters.getWordLocale('txt_konu')"
                />
                <div
                  v-bind:class="{
                    'float-end': true,

                    'char-count': true,
                  }"
                >
                  {{ form.subject.length }}/250
                </div>
                <div
                  class="form-error"
                  v-show="v$.form.subject.$errors.length > 0"
                >
                  {{ this.$store.getters.getWordLocale("txt_konu_giriniz") }}
                </div>
              </div>
              <div class="form-group">
                <textarea
                  minlength="6"
                  maxlength="700"
                  v-on:focusout="validateMessage"
                  v-model="form.message"
                  v-bind:class="{
                    'form-control': true,
                    'red-border': v$.form.message.$errors.length > 0,
                    'green-border':
                      messageOut && v$.form.message.$errors.length == 0,
                  }"
                  class="form-control"
                  :placeholder="this.$store.getters.getWordLocale('txt_mesaj')"
                  rows="3"
                ></textarea>

                <div
                  v-bind:class="{
                    'float-end': true,
                    'mb-3': true,
                  }"
                >
                  {{ form.message.length }}/700
                </div>
                <div
                  class="form-error"
                  v-show="v$.form.message.$errors.length > 0"
                >
                  {{ this.$store.getters.getWordLocale("txt_mesaj_giriniz") }}
                </div>
              </div>

              <div class="form-group d-flex justify-content-end w-100">
                <a
                  v-on:click="submitForm"
                  class="btn compnay-detail-form-btn"
                  href="javascript:;"
                  >{{ this.$store.getters.getWordLocale("txt_mesaj_gonder") }}
                  <abbr class="text-light" v-show="sendingMessage"
                    ><i class="fa fa-spinner fa-spin"></i
                  ></abbr>
                </a>
              </div>
            </form>

            <div
              class="alert mt-1 alert-success text-center"
              v-show="messageSent"
            >
              <i class="fa fa-info-circle"></i>
              {{
                this.$store.getters.getWordLocale(
                  "txt_mesajiniz_basariyla_gonderildi"
                )
              }}
            </div>

            <div
              class="alert mt-1 alert-danger text-center"
              v-show="errorSending"
            >
              <i class="fa fa-info-circle"></i>
              {{
                this.$store.getters.getWordLocale(
                  "txt_mesaj_gonderirken_hata_olustu"
                )
              }}
            </div>
          </div>
          <div class="detail-description-item">
            <div class="hr"></div>
          </div>
          <div class="detail-description-item">
            <span
              ><i class="material-icons-outlined"> map </i>
              {{ this.$store.getters.getWordLocale("txt_adres") }}</span
            >
            <strong>{{ contactPerson }}</strong>
            <p>
              {{ companyAddress }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="caurasel-box" v-if="companyProducts.length > 0">
      <div class="detail-description-item">
        <span
          ><i class="material-icons-outlined">image</i>{{ companyName }}
          <abbr>{{
            this.$store.getters.getWordLocale("txt_urun_resimleri")
          }}</abbr></span
        >
      </div>

      <carousel
        :autoplay="2000"
        v-if="companyProducts.length > 0"
        :settings="settings"
        :breakpoints="breakpoints"
      >
        <slide v-for="(product, pIndx) in companyProducts" :key="pIndx">
          <div class="carousel__item">
            <router-link
              class="product-item"
              :to="
                '/' +
                this.$store.state.langCodeX +
                '/' +
                product.productLink +
                '/' +
                companyUrlName.split(`-`).slice(0, 3).join(`-`) +
                '-' +
                companyId +
                '/' +
                companyCountry.toLowerCase().split(' ')[0] +
                '/export-products'
              "
            >
              <img
                :title="product.fullTitle"
                :src="'https://cdn.turkishexporter.com.tr' + product.image"
                alt=""
              />
              <small :title="product.fullTitle">{{ product.title }}</small>
            </router-link>
          </div>
        </slide>

        <template #addons>
          <div class="sider-btn">
            <Navigation />
          </div>
        </template>
      </carousel>
    </div>
    <div v-else>
      <div class="alert alert-warning">
        <i class="fa fa-info-circle"></i>
        {{
          this.$store.getters.getWordLocale(
            "txt_firmaya_ait_urun_bilgisi_bulunamadi"
          )
        }}
      </div>
    </div>

    <div class="tag-box">
      <div class="detail-description-item">
        <span
          ><i class="material-icons-outlined">tag</i>{{ companyName }}
          <abbr>{{
            this.$store.getters.getWordLocale("txt_urun_kelimeleri")
          }}</abbr></span
        >
      </div>
    </div>

    <div class="tag-list" v-if="productsKeywords.length > 0">
      <span
        class="tag-item"
        v-for="(keyword, ki) in productsKeywords"
        :key="ki"
        :title="keyword"
        >{{
          keyword.length > 50 ? keyword.substr(0, 50) + "..." : keyword
        }}</span
      >
    </div>
    <div v-else>
      <div class="alert alert-warning">
        <i class="fa fa-info-circle"></i>
        {{
          this.$store.getters.getWordLocale(
            "txt_firmaya_ait_anahtarkelime_bilgisi_bulunamadi"
          )
        }}
      </div>
    </div>
  </div>
</template>

<script>
import pageHeader from "./Components/Thema4PageHeader.vue";
import { Carousel, Navigation, Slide } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";
import helper from "./helper.js";
import moment from "moment";
import ForieLoader from "../shared/ForieLoader.vue";
import TeLoader from "../shared/TeLoader.vue";
import useValidate from "@vuelidate/core";
import { required, email, minLength, maxLength } from "@vuelidate/validators";

export default {
  components: {
    ForieLoader,
    TeLoader,
    Carousel,
    Slide,
    Navigation,
    pageHeader,
  },
  data() {
    return {
      companyUrlName: "",
      companyCountry: "",
      memebrshipIcon: "",
      logo: "",
      errorSending: false,
      messageSent: false,
      sendingMessage: false,
      submitted: false,
      v$: useValidate(),
      form: {
        nameSurname: "",
        email: "",
        companyName: "",
        country: "",
        subject: "",
        message: "",
      },
      years: "",
      productsKeywords: [],
      companyProducts: [],
      isVip: false,
      profiles: [],
      companyDetails: [],
      gettingSegments: true,
      showLoader: true,
      companyKeywords: "",
      companyName: "",
      membershipName: "",
      membershipIcon: "",
      employeeCount: "",
      companyCategories: [],
      companyDescription: "",
      certificates: " ",
      companySegments: [],
      brands: "",
      companyAddress: "",
      contactPerson: "",
      phone: "",
      sigmentsIdList: [],
      countries: [],
      companyId: 0,
      senderNameSurname: "",
      senderEmail: "",
      settings: {
        itemsToShow: 1.2,
        snapAlign: "center",
      },
      breakpoints: {
        700: {
          itemsToShow: 3.5,
          snapAlign: "center",
        },
        1024: {
          itemsToShow: 5,
          snapAlign: "start",
        },
      },
    };
  },
  validations() {
    return {
      userNameOut: false,
      emailOut: false,
      countryOut: false,
      subjectOut: false,
      messageOut: false,
      form: {
        nameSurname: { required },
        email: { required, email },
        country: { required },
        subject: { required, min: minLength(5), max: maxLength(250) },
        message: { required, min: minLength(6), max: maxLength(700) },
      },
    };
  },
  methods: {
    toTitles(s) {
      return s.replace(/\w\S*/g, function (t) {
        return t.charAt(0).toUpperCase() + t.substr(1).toLowerCase();
      });
    },
    changeLanguage(langCode) {
      this.$store.state.langCodeX = langCode;
    },
    setSelectedCountryId(e) {
      this.form.country = e.target.value.toLowerCase();
      this.validateCountry();
    },
    validateNamesurname() {
      this.userNameOut = true;

      this.v$.form.nameSurname.$validate();
    },
    validateCountry() {
      this.countryOut = true;
      return !(this.form.country == "");
    },
    validateEmail() {
      this.emailOut = true;
      this.v$.form.email.$validate();
    },
    validateSubject() {
      this.subjectOut = true;
      this.v$.form.subject.$validate();
    },
    validateMessage() {
      this.messageOut = true;
      this.v$.form.message.$validate();
    },
    submitForm() {
      this.messageSent = false;
      this.errorSending = false;

      this.submitted = true;
      this.v$.$validate(); // checks all inputs
      if (!this.v$.$error) {
        this.sendMessage();
      }
    },
    async sendMessage() {
      if (this.sendingMessage) {
        return 0;
      }

      this.sendingMessage = true;

      this.messageSent = false;
      this.errorSending = false;

      var result = [];

      var selectedCommPlatforms = "";
      await fetch(
        `${
          this.$store.state.apiUrlX
        }/api/v2/home/sendMessageToDomainCompanies/?name=${
          this.form.nameSurname
        }&subject=${this.form.subject}&message=${
          this.form.message
        }&countryCode=${this.form.country}&email=${
          this.form.email
        }&companyName=${
          this.form.companyName
        }&fax=&phone=&webSite=&address=&communicationPlatformIds=${selectedCommPlatforms}&targetCompanyIds=${parseInt(
          this.companyId
        )}`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "Public-WebAccessToken": this.$store.state.publicAccessTokenX,
            companyId: 0,
          },
          body: JSON.stringify({}),
        }
      )
        .then((res) => res.json())
        .then((data) => (result = data))
        .catch((err) => console.log(err.message));

      this.sendingMessage = false;
      if (result.resultText == "Success") {
        this.messageSent = true;
        this.clearSendingMessageForm();
      } else {
        this.errorSending = true;
      }
    },
    clearSendingMessageForm() {
      this.form.nameSurname = "";
      this.form.companyName = "";
      this.form.email = "";
      this.form.country = "";
      this.form.subject = "";
      this.form.message = "";
      this.submitted = false;
      this.v$.$reset();
    },
    async getCountries() {
      var tempList = [];

      await fetch(
        `https://data.mongodb-api.com/app/forienetwork_app-qolvc/endpoint/getCountries`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({}),
        }
      )
        .then((res) => res.json())
        .then((data) => (tempList = data))
        .catch((err) => console.log(err.message));

      this.countries = [];

      tempList.forEach((element) => {
        var countryId = parseInt(element._id);
        var countryCode = element.CountryCode;
        var name =
          element.Localizations.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          ).length > 0
            ? element.Localizations.filter(
                (q) => q.LangCode == this.$store.state.langCodeX
              )[0].Name
            : element.Localizations.filter(
                (q) => q.LangCode != this.$store.state.langCodeX
              ).length > 0
            ? element.Localizations.filter(
                (q) => q.LangCode != this.$store.state.langCodeX
              )[0].Name
            : element.TagName;

        this.countries.push({
          text: name,
          countryCode: countryCode,
          id: parseInt(countryId),
          flag: element.Flag,
        });
      });
    },
    async getCompany() {
      this.showLoader = true;

      await fetch(
        `https://data.mongodb-api.com/app/forienetwork_app-qolvc/endpoint/getCompanyBySecondaryId`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            companyId: parseInt(this.companyId),
          }),
        }
      )
        .then((res) => res.json())
        .then((data) => (this.companyDetails = data))
        .catch((err) => console.log(err.message));

      if (this.companyDetails == null) {
        alert(this.companyId);
        window.location.href = `/${this.$store.state.langCodeX}/not-found`;
      }
      this.logo =
        this.companyDetails.Logo == null
          ? this.$store.state.defaultLogoX
          : `https://cdn.turkishexporter.com.tr${this.companyDetails.Logo}`;

      this.logo = this.logo.toLowerCase();
      if (
        this.logo.indexOf(`companies/logo/1`) != -1 ||
        this.logo.indexOf(`companies/logo/logo`) != -1
      ) {
        this.logo = this.$store.state.defaultLogoX;
      }
      //helper.setCoverImage(this.companyDetails.BackgroundImage);

      const dateObject = new Date(this.companyDetails.CreateTime);

      var endDate = moment(new Date(), "YYYY");
      var createTime = moment(String(dateObject)).format("YYYY");

      var diff = endDate.diff(createTime, "years");
      if (diff != undefined && !isNaN(diff) && diff > 0) {
        this.years = diff;
      }

      this.companyName =
        this.companyDetails.Localizations.filter(
          (q) => q.LangCode == this.$store.state.langCodeX
        ).length > 0
          ? this.companyDetails.Localizations.filter(
              (q) => q.LangCode == this.$store.state.langCodeX
            )[0].Name
          : this.companyDetails.Localizations.filter(
              (q) => q.LangCode != this.$store.state.langCodeX
            )[0].Name;

      this.companyUrlName = `${this.companyName
        .toLowerCase()
        .trim()
        .split(" ")
        .join("-")}`;

      this.companyUrlName = this.companyUrlName.replace(/[^a-zA-Z0-9,-]/g, "");
      this.companyUrlName = this.companyUrlName.replace(/---/g, "-");
      this.companyUrlName = this.companyUrlName.replace(/--/g, "-");

      this.companyDescription =
        this.companyDetails.Localizations.filter(
          (q) =>
            q.LangCode == this.$store.state.langCodeX &&
            q.DescriptionContent != null
        ).length > 0
          ? this.companyDetails.Localizations.filter(
              (q) => q.LangCode == this.$store.state.langCodeX
            )[0].DescriptionContent
          : this.companyDetails.Localizations.filter(
              (q) => q.LangCode != this.$store.state.langCodeX
            )[0].DescriptionContent;

      this.fullDescription =
        this.companyDescription.length >= 250 ? false : true;

      this.companyDescription = helper.stripHtml(this.companyDescription);

      this.companyKeywords =
        this.companyDetails.Localizations.filter(
          (q) => q.LangCode == this.$store.state.langCodeX
        ).length > 0
          ? this.companyDetails.Localizations.filter(
              (q) => q.LangCode == this.$store.state.langCodeX
            )[0].Keywords
          : this.companyDetails.Localizations.filter(
              (q) => q.LangCode != this.$store.state.langCodeX
            )[0].Keywords;
      this.companyKeywords = this.companyKeywords.split(",");
      this.companyKeywords.forEach((kw) => {
        if (kw != "" && kw != undefined && kw != null) {
          this.productsKeywords.push(kw);
        }
      });

      this.companyCountry =
        this.companyDetails.Country.filter(
          (q) => q.LangCode == this.$store.state.langCodeX
        ).length > 0
          ? this.companyDetails.Country.filter(
              (q) => q.LangCode == this.$store.state.langCodeX
            )[0].Name
          : this.companyDetails.Country.filter(
              (q) => q.LangCode != this.$store.state.langCodeX
            )[0].Name;

      this.$store.state.detailsTitleX = `${this.companyName} - ${this.companyCountry}`;
      this.$store.state.detailsTitleX = this.$store.state.detailsTitleX.substr(
        0,
        70
      );
      var companyFirst4Words = this.companyName
        .split(" ")
        .slice(0, 4)
        .join(" ");

      var productName =
        this.companyDetails.Products.length > 0
          ? this.companyDetails.Products[0].Localizations.filter(
              (q) =>
                q.LangCode == this.$store.state.langCodeX &&
                q.Name != undefined &&
                q.Name != ""
            ).length > 0
            ? this.companyDetails.Products[0].Localizations.filter(
                (q) =>
                  q.LangCode == this.$store.state.langCodeX &&
                  q.Name != undefined &&
                  q.Name != ""
              )[0].Name
            : this.companyDetails.Products[0].Localizations.filter(
                (q) =>
                  q.LangCode != this.$store.state.langCodeX &&
                  q.Name != undefined &&
                  q.Name != ""
              ).length > 0
            ? this.companyDetails.Products[0].Localizations.filter(
                (q) =>
                  q.LangCode != this.$store.state.langCodeX &&
                  q.Name != undefined &&
                  q.Name != ""
              )[0].Name
            : ""
          : "";

      var homeDescription = this.$store.getters
        .getWordLocale("txt_anasayfa_seo_desc")
        .replace(`{1}`, companyFirst4Words)
        .replace("{2}", productName)
        .replace("{3}", this.companyCountry);

      this.$store.state.detailsDescriptionX = homeDescription;

      this.companyCountryCode =
        this.companyDetails.Country[0].Icon == null ||
        this.companyDetails.Country[0].Icon == ""
          ? ""
          : this.companyDetails.Country[0].Icon.toLowerCase();

      this.companyDetails.Localizations.forEach((element) => {
        var flagCode = element.LangCode;
        this.profiles.push(flagCode);
      });

      this.companyDetails.Categories.forEach((element) => {
        var categoryId = parseInt(element.MainCategoryId);
        this.companyCategories.push(categoryId);
      });

      this.companyDetails.Segments.forEach((element) => {
        var segmentId = parseInt(element);
        this.sigmentsIdList.push(segmentId);
      });

      this.isVip = this.companyDetails.IsVip;
      this.getCompanyInformation();
    },
    async getCompanyInformation() {
      var result = [];
      await fetch(
        `https://data.mongodb-api.com/app/forienetwork_app-qolvc/endpoint/getCompanyInformation`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            companyId: parseInt(this.companyId),
          }),
        }
      )
        .then((res) => res.json())
        .then((data) => (result = data))
        .catch((err) => console.log(err.message));

      this.buildCompanyInfo(result);
    },
    buildCompanyInfo(variable) {
      this.membershipName =
        variable.CompanyActiveMembership.Localizations.length == 0
          ? ""
          : variable.CompanyActiveMembership.Localizations.filter(
              (q) => q.LangCode == this.$store.state.langCodeX
            ).length > 0
          ? variable.CompanyActiveMembership.Localizations.filter(
              (q) => q.LangCode == this.$store.state.langCodeX
            )[0].Name
          : variable.CompanyActiveMembership.Localizations.filter(
              (q) => q.LangCode != this.$store.state.langCodeX
            )[0].Name;

      this.memebrshipIcon = variable.CompanyActiveMembership.Icon;

      variable.CompanyContactInformations.forEach((element) => {
        var address = element.Address;
        if (this.companyAddress == "") {
          this.companyAddress = address;
        }
        if (this.contactPerson == "") {
          this.contactPerson = element.ContactPearson;
        }

        element.Phones.forEach((tel) => {
          if (this.phone == "") {
            this.phone = tel;
          }
        });
      });

      var categories = [];
      if (this.companyCategories.length > 0) {
        var unique = this.companyCategories.filter(this.onlyUnique);
        unique.forEach((ele) => {
          var category = this.$store.state.mainCategoriesX.filter(
            (q) => parseInt(q._id) == ele
          );

          var categoryName =
            category[0].Localizations.length == 0
              ? ""
              : category[0].Localizations.filter(
                  (q) => q.LangCode == this.$store.state.langCodeX
                ).length > 0
              ? category[0].Localizations.filter(
                  (q) => q.LangCode == this.$store.state.langCodeX
                )[0].Name
              : category[0].Localizations.filter(
                  (q) => q.LangCode != this.$store.state.langCodeX
                )[0].Name;

          categories.push(categoryName);
        });

        this.companyCategories = [];
        this.companyCategories = categories;
      }

      this.brands = variable.CompanyCustomFields.Brands;
      this.certificates = variable.CompanyCustomFields.Certificates;
      this.employeeCount = variable.CompanyCustomFields.PersonelCount;

      this.getCompanySegments();
      this.showLoader = false;
    },
    async getCompanySegments() {
      this.gettingSegments = true;
      await fetch(
        `https://data.mongodb-api.com/app/forienetwork_app-qolvc/endpoint/getCompanySegments`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            segments: this.sigmentsIdList,
          }),
        }
      )
        .then((res) => res.json())
        .then((data) => (this.companySegments = data))
        .catch((err) => console.log(err.message));

      var segments = [];
      if (this.companySegments.length > 0) {
        this.companySegments.forEach((segment) => {
          var segmentName =
            segment.Localizations.length == 0
              ? ""
              : segment.Localizations.filter(
                  (q) => q.LangCode == this.$store.state.langCodeX
                ).length > 0
              ? segment.Localizations.filter(
                  (q) => q.LangCode == this.$store.state.langCodeX
                )[0].Name
              : segment.Localizations.filter(
                  (q) => q.LangCode != this.$store.state.langCodeX
                )[0].Name;

          segments.push(segmentName);
          this.$store.state.singleCompanySegmentNamesX.push(segmentName);
        });

        this.companySegments = [];
        this.companySegments = segments;

        this.gettingSegments = false;
      }
    },
    async getCompanyProducts() {
      var companies = [parseInt(this.companyId)];
      await fetch(
        `https://data.mongodb-api.com/app/forienetwork_app-qolvc/endpoint/getCompanyProducts`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            companies: companies,
            count: 20,
          }),
        }
      )
        .then((res) => res.json())
        .then((data) => (this.companyProducts = data))
        .catch((err) => console.log(err.message));

      var temp = [];
      if (this.companyProducts.length > 0) {
        this.companyProducts = this.companyProducts[0].Products;

        this.companyProducts.forEach((product) => {
          if (product.Images.length > 0) {
            var id = parseInt(product.Images[0]._id);
            var image = product.Images[0].Image;
            var title =
              product.Localizations.length == 0
                ? ""
                : product.Localizations.filter(
                    (q) => q.LangCode == this.$store.state.langCodeX
                  ).length > 0
                ? product.Localizations.filter(
                    (q) => q.LangCode == this.$store.state.langCodeX
                  )[0].Name
                : product.Localizations.filter(
                    (q) => q.LangCode != this.$store.state.langCodeX
                  )[0].Name;

            var fullTitle = title;
            title = title.length > 15 ? `${title.substr(0, 15)}...` : title;

            var description =
              product.Localizations.length == 0
                ? ""
                : product.Localizations.filter(
                    (q) => q.LangCode == this.$store.state.langCodeX
                  ).length > 0
                ? product.Localizations.filter(
                    (q) => q.LangCode == this.$store.state.langCodeX
                  )[0].Description
                : product.Localizations.filter(
                    (q) => q.LangCode != this.$store.state.langCodeX
                  )[0].Description;

            // var keywords =
            //   product.Localizations.length == 0
            //     ? ""
            //     : product.Localizations.filter(
            //         (q) => q.LangCode == this.$store.state.langCodeX
            //       ).length > 0
            //     ? product.Localizations.filter(
            //         (q) => q.LangCode == this.$store.state.langCodeX
            //       )[0].Keywords
            //     : product.Localizations.filter(
            //         (q) => q.LangCode != this.$store.state.langCodeX
            //       )[0].Keywords;

            // if (keywords != undefined && keywords != "") {
            //   keywords.split(",").forEach((element) => {
            //     this.productsKeywords.push(element);
            //   });
            // }

            var productLink = `${fullTitle
              .toLowerCase()
              .trim()
              .split(" ")
              .join("-")}-${id}`;

            productLink = productLink.replace(/[^a-zA-Z0-9,-]/g, "");
            productLink = productLink.replace(/---/g, "-");
            productLink = productLink.replace(/--/g, "-");

            if (image != undefined && image != "") {
              temp.push({
                image: image,
                title: title,
                fullTitle: fullTitle,
                description: description,
                productLink: productLink,
              });
            }
          }
        });

        if (this.productsKeywords.length == 0) {
          //this.productsKeywords = this.companyKeywords;
        }

        this.companyProducts = [];
        this.companyProducts = temp;
      }
    },
    onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    if (this.$store.state.userLoggedInX) {
      this.form.nameSurname = this.$store.state.userNameX;
      this.form.email = this.$store.state.userEmailX;
    }
    this.companyId = helper.getCompanyId(this.$route.params.id);
    this.getCompanyProducts();
    this.getCountries();
    this.getCompany();
  },
};
</script>

  <style>
</style>
<style lang="postcss">
.tag-box {
  margin-top: 78px;
}

.carousel {
  margin-bottom: 45px;
  margin-top: 32px;
}

.carousel__item {
  min-height: 200px;
  width: 100%;
  background-color: var(--m3--sys--light--background);
  color: rgb(0, 0, 0);
  font-size: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  margin-right: 10px;
  border: 1px solid var(--m3--read-only--light--outline--opacity-008);
  box-sizing: border-box;
  border-radius: 12px;
  overflow: hidden;
}

.carousel__item small {
  display: flex;
  white-space: pre;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 100%;
  padding-top: 16px;
  padding-left: 16px;
  padding-bottom: 16px;
  color: var(--m3--sys--light--on-surface);
}

.carousel__item img {
  max-width: 200px;
  height: 124px;
}

.hr {
  height: 1px;
  margin: 32px 0;
  background-color: var(--m3--read-only--light--outline--opacity-016);
}

.membership-package-description > a {
  /* M3/sys/light/on-primary */
  background: var(--m3--sys--light--on-primary);
  /* M3/read-only/light/outline/opacity-0.16 */
  border: 1px solid var(--m3--read-only--light--outline--opacity-016);
  box-sizing: border-box;
  border-radius: 8px;
  margin-right: 8px;
  padding: 6px 16px;
  display: flex;
  margin-bottom: 8px;
  min-width: 180px;
  justify-content: center;
}

.membership-package-description > a > span {
  /* M3/label/large */
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;
  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: 0.1px;
  font-feature-settings: "liga" off;
  color: var(--m3--read-only--dark--black);
}

.membership-package-description > a > img {
  margin-right: 8px;
}
</style>
<style lang="postcss">
.gallery-item {
  display: none;
}

.gallery-item:first-child {
  display: block !important;
}

.did-floating-label-content {
  position: relative;
  min-width: 187px;
}

.did-floating-label {
  color: #1e4c82;
  font-size: 13px;
  font-weight: normal;
  position: absolute;
  pointer-events: none;
  left: 15px;
  top: 20px;
  padding: 0 5px;
  background: var(--m3--sys--light--on-primary);
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}

.did-floating-input,
.did-floating-select {
  font-size: 12px;
  display: block;
  width: 100%;
  height: 56px;
  padding: 0 20px;
  background: var(--m3--sys--light--on-primary);
  border-radius: 4px;
  box-sizing: border-box;

  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;
  letter-spacing: 0.5px;

  /* M3/sys/light/on-surface */
  color: var(--m3--sys--light--on-surface-variant);
}

.did-floating-input:focus,
.did-floating-select:focus {
  outline: none;
  box-shadow: none !important;
}

.did-floating-input:focus ~ .did-floating-label,
.did-floating-select:focus ~ .did-floating-label {
  top: -8px;
  font-size: 13px;
}

select.did-floating-select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

select.did-floating-select::-ms-expand {
  display: none;
}

.did-floating-input:not(:placeholder-shown) ~ .did-floating-label {
  top: -8px;
  font-size: 13px;
}

.did-floating-select:not([value=""]):valid ~ .did-floating-label {
  top: -8px;
  font-size: 13px;
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  /* identical to box height, or 133% */
  letter-spacing: 0.5px;
  /* M3/sys/light/primary */
  color: var(--m3--sys--light--primary);
}

.did-floating-select[value=""]:focus ~ .did-floating-label {
  top: 20px;
  font-size: 13px;
}

.did-floating-select:not([multiple]):not([size]) {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='6' viewBox='0 0 8 6'%3E%3Cpath id='Path_1' data-name='Path 1' d='M371,294l4,6,4-6Z' transform='translate(-371 -294)' fill='%23003d71'/%3E%3C/svg%3E%0A");
  background-position: right 15px top 50%;
  background-repeat: no-repeat;
}

.input-group {
  display: flex;
}

.input-group .did-floating-input {
  border-radius: 0 4px 4px 0;
  border-left: 0;
  padding-left: 0;
}

.input-group-append {
  display: flex;
  align-items: center;
  /*   margin-left:-1px; */
}

.input-group-text {
  display: flex;
  align-items: center;
  font-weight: 400;
  height: 34px;
  padding: 0 5px 0 20px;
  font-size: 12px;
  text-align: center;
  white-space: nowrap;
  border-radius: 4px 0 0 4px;
  border-right: none;
}

option {
  /* M3/read-only/light/surface2 */
  background: var(--m3--read-only--light--surface2);
  /* M3/Elevation Light/2 */
  border-radius: 4px;
}

option:hover,
select:focus > option:checked {
  background: var(--m3--read-only--light--primary--opacity-012) !important;
  background-color: var(
    --m3--read-only--light--primary--opacity-012
  ) !important;
}

.visibility {
  visibility: hidden !important;
}

.mt-10p {
  margin-top: 10% !important;
}

.bg-trans {
  background: transparent !important;
}

.form-error {
  width: 100%;
  margin-bottom: 0.5rem;
  font-size: 0.875em;
  color: #dc3545;
}

.did-floating-label-content {
  padding-bottom: 0 !important;
}

.company-detail-form .form-control {
  font-size: 14px !important;
  color: black;
}

.red-border {
  border-color: #e1000f !important;
}

.green-border {
  border-color: #99c99b !important;
}
</style>
